import some from "lodash-es/some";

import { useProjects } from "@/components/nw-nav/store/queries/project";
import { getFromQueryString } from "@/utils/url";
import { Project, Track } from "@/api";
import { IconName } from "@/components";
import { ProjectCategories } from "@/models";

/**
 * @returns [seriesOrder, projectOrder]
 */
export function getOrder(project: Project): { seriesOrder: string; projectOrder: string | undefined } | undefined {
  if (project.metadata?.order != null) {
    const [seriesOrder, projectOrder] = project.metadata?.order?.split(".") as [string, string];
    return { seriesOrder, projectOrder };
  }

  return undefined;
}

export function getIconForCategory(category: ProjectCategories | string): IconName | undefined {
  switch (category) {
    case "Account Management":
      return "settings-cog";
    case "Analytics":
      return "bar-chart";
    case "AI / ML":
      return "wand";
    case "Cloud DevOps":
      return "code";
    case "Compute":
      return "terminal-circle";
    case "Containers":
      return "container";
    case "Cost Economics":
      return "currency-dollar";
    case "Databases":
      return "database";
    case "Global Infrastructure":
      return "server";
    case "Networks":
      return "dataflow";
    case "Security":
      return "lock";
    case "Storage":
      return "cloud";
    default:
      return undefined;
  }
}

export function getUrlForProject(id: string): string {
  const base = `/projects/${id}`;
  const track = getFromQueryString("track");

  if (track) {
    const nextProject = useProjects().getProjectById(id);

    if (track === "no") {
      if (nextProject && hasTrack(track, nextProject)) {
        return `${base}?track=${track}`;
      }
      return `${base}?track=low`;
    } else if (nextProject && hasTrack(track, nextProject)) {
      return `${base}?track=${track}`;
    }
  }

  return base;
}

function hasTrack(trackId: Track["id"], project: Project): boolean {
  return some(project.metadata?.tracks, t => t.id === trackId);
}
